import {adminAxios} from '@/Plugins/Axios';

const apiBaseURL = process.env.VUE_APP_BASE_API_URL_HTTP ||
    (process.env.VUE_APP_BASE_API_URL || '').replace(/\/admin\/?$/, '/');

const apiConfig = apiBaseURL ? {baseURL: apiBaseURL} : {};

const fallbackFilename = () => {
    return `employee-registration-kpi-${new Date().toISOString().slice(0, 10)}.xlsx`;
};

const detailFallbackFilename = (employeeId) => {
    return `employee-${employeeId}-customer-detail-${new Date().toISOString().slice(0, 10)}.xlsx`;
};

function parseFilenameFromContentDisposition(headerValue, fallback = fallbackFilename()) {
    if (!headerValue) {
        return fallback;
    }

    const filenameStarMatch = headerValue.match(/filename\*\s*=\s*(?:UTF-8'')?([^;]+)/i);
    if (filenameStarMatch && filenameStarMatch[1]) {
        try {
            return decodeURIComponent(filenameStarMatch[1].trim().replace(/^"|"$/g, ''));
        } catch (e) {
            return filenameStarMatch[1].trim().replace(/^"|"$/g, '');
        }
    }

    const quotedFilenameMatch = headerValue.match(/filename\s*=\s*"([^"]+)"/i);
    if (quotedFilenameMatch && quotedFilenameMatch[1]) {
        return quotedFilenameMatch[1];
    }

    const filenameMatch = headerValue.match(/filename\s*=\s*([^;]+)/i);
    if (filenameMatch && filenameMatch[1]) {
        return filenameMatch[1].trim();
    }

    return fallback;
}

export async function fetchBranches() {
    const response = await adminAxios.get('v1/listing/branches', apiConfig);
    const data = response.data;
    if (Array.isArray(data)) return data;
    if (data && Array.isArray(data.data)) return data.data;
    return [];
}

export async function fetchKpiAll(params = {}) {
    const response = await adminAxios.get('register-customer-by-employee/kpi/all', {
        ...apiConfig,
        params
    });

    return response.data;
}

export async function downloadKpiAllExport(params = {}) {
    const response = await adminAxios.get('register-customer-by-employee/kpi/all/export', {
        ...apiConfig,
        params,
        responseType: 'blob'
    });

    return {
        blob: new Blob([response.data]),
        filename: parseFilenameFromContentDisposition(response.headers['content-disposition'])
    };
}

export async function fetchKpiAllDetail(employeeId, params = {}) {
    const response = await adminAxios.get(`register-customer-by-employee/kpi/all/${employeeId}/detail`, {
        ...apiConfig,
        params
    });

    return response.data;
}

export async function downloadKpiAllDetailExport(employeeId, params = {}) {
    const response = await adminAxios.get(`register-customer-by-employee/kpi/all/${employeeId}/detail/export`, {
        ...apiConfig,
        params,
        responseType: 'blob'
    });

    return {
        blob: new Blob([response.data]),
        filename: parseFilenameFromContentDisposition(
            response.headers['content-disposition'],
            detailFallbackFilename(employeeId)
        )
    };
}
